import { MeasurementUnitSystem } from '@strava/mre';
import { UnitSystem } from '@strava/units';

// This function maps Strava unit systems to MRE measurement unit systems.
export const mapUnitSystemToMREUnitSystem = (
  unitSystem: UnitSystem
): MeasurementUnitSystem => {
  switch (unitSystem) {
    case 'imperial':
      return MeasurementUnitSystem.IMPERIAL;
    case 'metric':
      return MeasurementUnitSystem.METRIC;
    default:
      throw new Error(`Unsupported unit system: ${unitSystem}`);
  }
};
